import Link from 'next/link';
import { theme, websiteColors } from '../../themes/Theme';
import React from 'react';

interface Rating {
  id: string;
  name: string;
  rating: number;
  link: string;
}

const ratingData: Rating[] = [
  {
    id: 'capterra',
    name: 'Capterra',
    rating: 4.8,
    link: 'https://www.capterra.com/p/265126/KonfHub/',
  },
  {
    id: 'softwareAdvice',
    name: 'Software Advice',
    rating: 4.7,
    link: 'https://www.softwareadvice.com/event-management/konfhub-profile/reviews/',
  },
  {
    id: 'getApp',
    name: 'GetApp',
    rating: 4.8,
    link: 'https://www.getapp.com/customer-management-software/a/konfhub/',
  },
  {
    id: 'Gartner Peer Insights',
    name: 'Gartner Peer Insights',
    rating: 4.8,
    link: 'https://www.gartner.com/reviews/market/event-technology-platforms/vendor/konfhub?utm_source=konfhub&utm_medium=referral&utm_campaign=widget&utm_content=N2FlMzFmMzktZjcxZS00MDhhLTk3ZTQtODYyYzgyN2NjMzJk',
  },
];

const linkStyle: React.CSSProperties = {
  textDecoration: 'none',
  color: '#212529',
};

const HomeRating: React.FC = () => {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center pt-4 px-lg-5 px-4">
        <section className="ratings-section m-auto text-center py-4">
          <div
            style={{ maxWidth: '790px' }}
            className="d-flex rating-hero-cont flex-wrap justify-content-center gap-3 gap-sm-3 gap-5"
          >
            {ratingData.map((rating) => (
              <div
                key={rating.id}
                className="my-3"
                style={{ maxWidth: '260px' }}
              >
                <div className="rating">
                  <img src="/img/star-count.svg" alt="star count" />
                  <Link href={rating.link} style={linkStyle} target="_blank">
                    <p>
                      {rating.rating}/5{' '}
                      <span className="font-sm-2 fw-semibold text-secondary text-nowrap">
                        {rating.name}
                      </span>
                    </p>
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-3">
            <Link
              href="https://www.g2.com/products/konfhub/reviews"
              target="_blank"
            >
              <button className="gartner-btn fw-bold font-sm">
                Review us on Gartner
              </button>
            </Link>
          </div>
        </section>
      </div>

      <style jsx>{`
        .ratings-section {
          max-width: 700px;
          width: 100%;
        }
        .host-btn,
        .demo-btn,
        .gartner-btn {
          box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
          font-weight: 700;
          border-radius: 4px;
        }
        .host-btn {
          background-color: ${websiteColors[theme].primaryWebsiteTheme};
          color: #fff;
          padding: 5px 40px;
        }
        .gartner-btn {
          background-color: ${websiteColors[theme].primaryWebsiteTheme};
          color: #fff;
          padding: 5px 10px;
        }
        .demo-btn {
          background-color: #fff;
          color: ${websiteColors[theme].primaryWebsiteTheme};
          border: 1px solid ${websiteColors[theme].primaryWebsiteTheme};
          padding: 5px 40px;
        }

        @media screen and (max-width: 576px) {
          .rating-hero-cont {
            gap: 0px !important;
          }
          .host-btn,
          .demo-btn {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default HomeRating;
